import React, { Component } from 'react';
import { IMAGE_BASE_URL } from '../data/API_LINKS';

class VendorGiftDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGift: null,
      showUserDetails: false
    };
  }

  handleGiftSelect = (gift) => {
    console.log(gift);
    this.setState({ selectedGift: gift, showUserDetails: true });
  };

  toggleUserDetails = () => {
    this.setState(prevState => ({ showUserDetails: !prevState.showUserDetails }));
  };

  // Format date to MMM DD, YYYY at h:mm AM/PM
  formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    
    // Check for invalid date
    if (isNaN(date.getTime())) return 'Invalid date';
    
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
    
    return date.toLocaleDateString('en-US', options);
  };
  
  // Format date to shorter MMM DD, YYYY
  formatShortDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    
    // Check for invalid date
    if (isNaN(date.getTime())) return 'Invalid date';
    
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric'
    };
    
    return date.toLocaleDateString('en-US', options);
  };

  renderUserDetails(user) {
    if (!user) return <p className="text-gray-500 italic">No user assigned</p>;

    return (
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h4 className="font-semibold text-lg text-gray-800 mb-4 border-b pb-2">Recipient Information</h4>
        <div className="flex flex-col md:flex-row gap-6">
          <div className="md:w-1/3">
            <div className="bg-gray-50 p-4 rounded-md">
              <p className="text-sm text-gray-500 mb-1">User ID</p>
              <p className="font-medium text-gray-800">{user.id}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-md mt-3">
              <p className="text-sm text-gray-500 mb-1">Full Name</p>
              <p className="font-medium text-gray-800">{user.first_name} {user.last_name}</p>
            </div>
          </div>
          
          <div className="md:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="bg-gray-50 p-4 rounded-md">
              <p className="text-sm text-gray-500 mb-1">Email Address</p>
              <p className="font-medium text-gray-800 break-words">{user.email}</p>
            </div>
            
            <div className="bg-gray-50 p-4 rounded-md">
              <p className="text-sm text-gray-500 mb-1">Phone Number</p>
              <p className="font-medium text-gray-800">{user.phone || 'Not provided'}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderGiftDetail(gift) {
    const giftImageUrl = gift.image ? `${IMAGE_BASE_URL}${gift.image}` : null;

    return (
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="bg-gray-800 text-white p-4">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-semibold">Gift ID: {gift.gift_id}</h3>
            {gift.user && (
              <button 
                onClick={this.toggleUserDetails}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                {this.state.showUserDetails ? 'Hide Recipient' : 'Show Recipient'}
              </button>
            )}
          </div>
        </div>
        
        <div className="p-6">
          <div className="flex flex-col md:flex-row gap-6">
            {/* Gift Image */}
            <div className="md:w-1/3">
              {giftImageUrl ? (
                <div className="rounded-lg overflow-hidden border border-gray-200">
                  <img 
                    src={giftImageUrl} 
                    alt={`Gift ${gift.gift_id}`}
                    className="w-full h-64 object-cover"
                  />
                </div>
              ) : (
                <div className="w-full h-64 bg-gray-100 rounded-lg flex items-center justify-center">
                  <span className="text-gray-400">No gift image available</span>
                </div>
              )}
            </div>
            
            {/* Gift Details */}
            <div className="md:w-2/3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-500 mb-1">Reference ID</p>
                  <p className="font-medium text-gray-800">{gift.id}</p>
                </div>
                
                <div className="p-4 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-500 mb-1">Gift ID</p>
                  <p className="font-medium text-gray-800">{gift.gift_id}</p>
                </div>
                
                <div className="p-4 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-500 mb-1">Creation Date</p>
                  <p className="font-medium text-gray-800">{this.formatDate(gift.created_at)}</p>
                </div>
                
                <div className="p-4 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-500 mb-1">Last Updated</p>
                  <p className="font-medium text-gray-800">{this.formatDate(gift.updated_at)}</p>
                </div>
                
                <div className="p-4 bg-gray-50 rounded-md md:col-span-2">
                  <p className="text-sm text-gray-500 mb-1">Recipient</p>
                  <p className="font-medium text-gray-800">
                    {gift.user ? `${gift.user.first_name} ${gift.user.last_name}` : 'Unassigned'}
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* User Details Section */}
          {this.state.showUserDetails && gift.user && (
            <div className="mt-6">
              {this.renderUserDetails(gift.user)}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { givenGifts } = this.props;
    const { selectedGift } = this.state;


    if (!givenGifts || givenGifts.length === 0) {
      return (
        <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">No Claimed Gifts</h2>
          <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded">
            <p className="text-red-700">No gifts have been Claimed yet yet.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="p-6 bg-gray-50 rounded-lg">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Claimed Gifts</h2>
        
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/3">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <div className="bg-gray-800 text-white p-4">
                <h3 className="text-lg font-medium">Assigned Gifts ({givenGifts.length})</h3>
              </div>
              
              <div className="divide-y divide-gray-100 max-h-96 overflow-y-auto">
                {givenGifts.map(gift => (
                  <div 
                    key={gift.id}
                    onClick={() => this.handleGiftSelect(gift)}
                    className={`p-4 cursor-pointer transition-all hover:bg-gray-50 ${
                      selectedGift && selectedGift.id == gift.id 
                        ? 'bg-red-50 border-l-4 border-red-500' 
                        : ''
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {gift.image && (
                        <img 
                          src={`${IMAGE_BASE_URL}${gift.image}`} 
                          alt={`Gift ${gift.gift_id}`}
                          className="w-12 h-12 rounded object-cover border border-gray-200"
                        />
                      )}
                      <div>
                        <p className="font-medium text-gray-800">Gift #{gift.gift_id}</p>
                        <p className="text-sm text-gray-600">
                          {gift.user ? `${gift.user.first_name} ${gift.user.last_name}` : 'Unassigned'}
                        </p>
                        <p className="text-xs text-gray-400">
                          {this.formatShortDate(gift.created_at)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="lg:w-2/3">
            {selectedGift ? (
              this.renderGiftDetail(selectedGift)
            ) : (
              <div className="bg-white rounded-xl shadow-sm h-64 flex items-center justify-center">
                <div className="text-center p-6">
                  <svg className="w-12 h-12 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                  </svg>
                  <p className="text-gray-500">Select a gift from the list to view details</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VendorGiftDetails;